module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable","prototype"],"commonjs":"rxjs/operator/map","commonjs2":"rxjs/operator/map","amd":"rxjs/operator/map"}
// module id = 4
// module chunks = 0 1